import axios from 'axios';
import {apiBaseUrl} from "../../../helpers/UrlHelper";
import {loginToken} from '../../../helpers/LocalStorageHelper'
import {handleError} from '../../../helpers/ErrorHelper'

function _success(success) {
    return {type: 'GET_ALL_INVOICE_SUCCESS', success};
}

function _error(error) {
    return {type: 'GET_ALL_INVOICE_ERROR', error};
}

function _processing(processing) {
    return {type: 'GET_ALL_INVOICE_PROCESSING', processing};
}

function getAllInvoice() {
    return (dispatch,getState) => {
        dispatch(_processing(true));
        dispatch(_success(null));
        dispatch(_error(null));
        let {allInvoiceList} = getState();
        let {params} = allInvoiceList.data
        const request = axios({

            url: apiBaseUrl(`admin/payments/invoices`),
            method: "get",
            dataType: 'json',
            params,
            headers: {'Authorization': 'Bearer ' + loginToken()}
        })
            .then(function (res) {
                dispatch(_success(res));
                dispatch(_processing(false));
            }).catch(function (error) {
                dispatch(_error(error));
                dispatch(_processing(false));
                handleError(error)
            });

        return {
            type: 'GET_INVOICE_SUCCESS',
            payload: request
        }
    }
}


export default getAllInvoice;